import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import BankaTaksitBilgileri from "./pages/BankaTaksitBilgileri";
import DegisimIadeProseduru from "./pages/DegisimIadeProseduru";
import FirmaBilgiFormu from "./pages/FirmaBilgiFormu";
import Kvkk from "./pages/Kvkk";
import SportiveSahaGizlilikPolitikasi from "./pages/SportiveSahaGizlilikPolitikasi";
import MobilKurulum from "./pages/MobilKurulum";
import KurulumKilavuzu from "./pages/KurulumKilavuzu";
import KurulumKilavuzuDomain from "./pages/KurulumKilavuzuDomain";
import "./App.css";

function App() {
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/banka-taksit" element={<BankaTaksitBilgileri />} />
            <Route path="/degisim-iade" element={<DegisimIadeProseduru />} />
            <Route path="/kvkk" element={<Kvkk />} />
            <Route path="/firma-bilgi-formu" element={<FirmaBilgiFormu />} />
            <Route path="/sportivesaha-gizlilik-politikasi" element={<SportiveSahaGizlilikPolitikasi />} />
            <Route path="/mobil-kurulum" element={<MobilKurulum />} />
            <Route path="/kurulum-kilavuzu-local" element={<KurulumKilavuzu />} />
            <Route path="/kurulum-kilavuzu-domain" element={<KurulumKilavuzuDomain />} />
        </Routes>
    );
}

export default App;
